import { useState } from "react";
import { Alert, Collapse, IconButton } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

interface AlertFirmaPropsInterface {
  title: string;
  [x: string]: any;
}
export const AlertFirma = ({ title, ...props }: AlertFirmaPropsInterface) => {
  const [open, setOpen] = useState(true);

  const handleCloseAlert = () => {
    setOpen((prev) => !prev);
  };
  return (
    <Collapse in={open}>
      <Alert
        {...props}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => handleCloseAlert()}
          >
            <IoMdCloseCircleOutline fontSize="inherit" />
          </IconButton>
        }
      >
        {title}
      </Alert>
    </Collapse>
  );
};
